@for (segment of segments; track segment) {
  @if (segment.percentage) {
    <div [style.width.%]="segment.percentage" class="h-full {{ segment.color }}"></div>
  }
}
